import React from 'react';
import { Card, Container } from 'react-bootstrap';

// Define styles that might be reused or changed often
const roundedStyle = { borderRadius: '15px' };
const topRoundedStyle = { ...roundedStyle, borderRadius: '15px 15px 0 0' };

const HomePage = () => {
    return (
        <Container className="mt-5">
            <Card className="text-center p-4 mb-3" style={roundedStyle}>
                <Card.Body>
                    <h1>Welcome to FitOps!</h1>
                    <p>Compete to become the Minister of Activity or... prepare to bring cake!</p>
                    <hr className="my-4 bg-light" />
                    <p>Participate every month and track your rankings and rewards!</p>
                </Card.Body>
            </Card>

            <Card className="mb-3" style={roundedStyle}>
                <Card.Img variant="top" src="https://www.houstonmethodist.org/-/media/images/contenthub/article-images/sports-medicine/2022/hub_commonrunninginjuries_article.ashx" style={topRoundedStyle} alt="Monthly Activity" />
                <Card.Body>
                    <Card.Title>Next Event: Minister of Activity</Card.Title>
                    <Card.Text>
                        This event runs every month. The winner is crowned as the Minister of Activity and enjoys the glory!
                        The one who finishes last has the sweet duty of providing cake for the other participants.
                    </Card.Text>
                    <Card.Text>
                        <small className="text-muted">Happening every month.</small>
                    </Card.Text>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default HomePage;
